import { Link } from 'react-router-dom'
import {
  ActionIcon,
  Button,
  Navbar,
  useAppShell,
  useNavbarLayout,
} from '@workwhile/web-ui'
import { useIntercom } from 'react-use-intercom'
import {
  HeadphonesIcon,
  PanelLeftCloseIcon,
  PanelLeftOpenIcon,
  PlusCircleIcon,
} from 'lucide-react'
import { PermissionEnum } from 'api/userPermissions'
import { AuthGuard } from 'components/auth'

const CREATE_SHIFT_PATH = '/home/shift-editor/new'

export const CtaButtons = () => {
  const { show: showIntercom } = useIntercom()
  const { toggleNavbar } = useAppShell()
  const layout = useNavbarLayout()
  const isClosed = layout === 'closed'

  const onSupportClick = () => {
    showIntercom()
    // The shell only closes the phone menu on link clicks
    if (layout === 'mobile') {
      toggleNavbar()
    }
  }

  return (
    <Navbar.Footer>
      <AuthGuard.Permission value={PermissionEnum.ManageShifts}>
        {isClosed ? (
          <ActionIcon
            component={Link}
            to={CREATE_SHIFT_PATH}
            icon={PlusCircleIcon}
            aria-label={'Create Shift'}
          />
        ) : (
          <Button
            component={Link}
            to={CREATE_SHIFT_PATH}
            leftIcon={PlusCircleIcon}
            fullWidth
          >
            Create Shift
          </Button>
        )}
      </AuthGuard.Permission>
      {isClosed ? (
        <ActionIcon
          variant={'outline'}
          icon={HeadphonesIcon}
          aria-label={'Contact Support'}
          onClick={onSupportClick}
        />
      ) : (
        <Button
          variant={'outline'}
          leftIcon={HeadphonesIcon}
          fullWidth
          onClick={onSupportClick}
        >
          Support
        </Button>
      )}
      {layout === 'open' ? (
        <Button
          variant={'subtle'}
          leftIcon={PanelLeftCloseIcon}
          fullWidth
          onClick={toggleNavbar}
        >
          Collapse sidebar
        </Button>
      ) : null}
      {isClosed ? (
        <ActionIcon
          variant={'subtle'}
          icon={PanelLeftOpenIcon}
          aria-label={'Expand sidebar'}
          onClick={toggleNavbar}
        />
      ) : null}
    </Navbar.Footer>
  )
}
